











































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { CompanyStructureForPlanningResponse } from '@/types/service-response'
import {
  FETCH_EMPLOYEE_HIERARCHY_LIST,
  LOAD_COMPANY_STRUCTURE,
  UPDATE_EMPLOYEE_HIERARCHY_LIST
} from '@/store/action-types'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import { EmployeeHierarchyPayload } from '@/types/payload'
import { EmployeeHierarchyList } from '@/model/settings/EmployeeHierarchyList'

interface ComponentData {
  gridOptions: any
  columnDefs: any
  gridData: Array<EmployeeHierarchyList>
  fromIndex: number | undefined
  toIndex: number | undefined
  planningGroupList: Array<PlanningGroup>
  selectedPlanningGroupId: number | undefined
  isSubmitButtonDisabled: boolean
  loading: boolean
  showSnackbar: boolean
  messageSnackbar: TranslateResult | string
  snackbarState: number
}

export default Vue.extend({
  name: 'EmployeeHierarchyPage',

  components: {
    AgGridVue
  },

  props: {
    departmentId: Number
  },

  data (): ComponentData {
    return {
      gridOptions: {},
      columnDefs: [
        { headerName: this.$t('settings.employeeHierarchy.position').toString(), field: 'position', rowDrag: true },
        { headerName: this.$t('settings.employeeHierarchy.name').toString(), field: 'name' },
      ],
      gridData: [],
      fromIndex: undefined,
      toIndex: undefined,
      planningGroupList: [],
      selectedPlanningGroupId: undefined,
      isSubmitButtonDisabled: true,
      loading: false,
      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0
    }
  },

  computed: {
    filteredPlanningGroupList () {
      const planningGroupList: Array<PlanningGroup> = this.planningGroupList.filter((item: PlanningGroup) => item.department === this.departmentId)
      return planningGroupList
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  watch: {
    departmentId (newVal: number): void {
      if(newVal) {
        this.selectedPlanningGroupId = undefined
        this.gridData = []

        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    }
  },

  methods: {
    onRowDragEnter (e: any): void {
      this.fromIndex = e.overIndex
    },

    onRowDragEnd (e: any): void {
      this.toIndex = e.overIndex
      if (this.fromIndex !== this.toIndex) {
        const from = this.gridData[this.fromIndex!]
        this.gridData.splice(this.fromIndex!, 1)
        this.gridData.splice(e.overIndex, 0, from)
      }

      this.gridData = EmployeeHierarchyList.updatePosition(this.gridData)
    },

    async onSaveButtonClick (): Promise<void> {
      if (this.selectedPlanningGroupId) {
        const sortedEmployees: Array<number> = this.gridData.map((item: EmployeeHierarchyList) => {
          return item.id
        })
        const payload: EmployeeHierarchyPayload = {
          departmentId: this.departmentId,
          planningGroupId: this.selectedPlanningGroupId,
          sortedEmployees: sortedEmployees
        }

        try {
          this.loading = true
          const employeeList: Array<EmployeeHierarchyList> = await this.$store.dispatch(UPDATE_EMPLOYEE_HIERARCHY_LIST, payload)
          this.loading = false
          this.gridData = _.cloneDeep(employeeList)
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } catch (e) {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    async onFilterValueChange () {
      if (this.selectedPlanningGroupId) {
        this.isSubmitButtonDisabled = false
        const payload: EmployeeHierarchyPayload = {
          departmentId: this.departmentId,
          planningGroupId: this.selectedPlanningGroupId
        }
        const employeeList: Array<EmployeeHierarchyList> = await this.$store.dispatch(FETCH_EMPLOYEE_HIERARCHY_LIST, payload)
        this.gridData = _.cloneDeep(employeeList)
      }
    }

  },

  async mounted () {
    const responseData: CompanyStructureForPlanningResponse = await this.$store.dispatch(LOAD_COMPANY_STRUCTURE)
    this.planningGroupList = PlanningGroup.createFromResponse(responseData)

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }

})
